/**
 * @generated SignedSource<<ad21e67e1ca3d3801f1565e8a88c5584>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScrapImageUpdateInput = {
  id: string;
  problems: ReadonlyArray<Upload>;
  solutions: ReadonlyArray<Upload>;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type ScrapCreateDialog_scrapImageUpdateMutation$variables = {
  input: ScrapImageUpdateInput;
};
export type ScrapCreateDialog_scrapImageUpdateMutation$data = {
  readonly scrapImageUpdate: {
    readonly id: string;
    readonly problems: ReadonlyArray<{
      readonly id: string;
      readonly objectUrl: string;
    }>;
    readonly solutions: ReadonlyArray<{
      readonly id: string;
      readonly objectUrl: string;
    }>;
  };
};
export type ScrapCreateDialog_scrapImageUpdateMutation = {
  response: ScrapCreateDialog_scrapImageUpdateMutation$data;
  variables: ScrapCreateDialog_scrapImageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "objectUrl",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Scrap",
    "kind": "LinkedField",
    "name": "scrapImageUpdate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "problems",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "File",
        "kind": "LinkedField",
        "name": "solutions",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ScrapCreateDialog_scrapImageUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ScrapCreateDialog_scrapImageUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a6e5a0db0daf9318be5a5d2ab858315b",
    "id": null,
    "metadata": {},
    "name": "ScrapCreateDialog_scrapImageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ScrapCreateDialog_scrapImageUpdateMutation(\n  $input: ScrapImageUpdateInput!\n) {\n  scrapImageUpdate(input: $input) {\n    id\n    problems {\n      id\n      objectUrl\n    }\n    solutions {\n      id\n      objectUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e415422d51c540abe5ffa810972187cf";

export default node;
